import { render, staticRenderFns } from "./LoginControls.vue?vue&type=template&id=5945fcb0&"
import script from "./LoginControls.vue?vue&type=script&lang=js&"
export * from "./LoginControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports